import React from 'react'
import { bindActionCreators } from 'redux'
import { browserHistory } from 'react-router'
import {
    Button, LoadMore, Dialog
} from 'react-weui'
import { connect } from 'react-redux'
import * as relaycfmAction from '../actions/relayConfirm'
import { RelayConfirmChannel, RelayConfirmLecture } from '../components/relayConfirm'
import { renderMoney } from '../utils'
import { Page, WKVisible, Pay } from '../components'


class RelayConfirmPage extends React.Component {
    constructor (props) {
        super(props)
        this.primaryBtnStyle = {
            type: 'primary',
            label: '确定',
        }
        this.cancleBtnStyle = {
            type: 'default',
            label: '取消',
            onClick: () => this.onClickCancle()
        }
    }
    componentDidMount() {
        const { type, id } = this.props.location.query
        switch (type) {
            case 'lecture':
                this.props.relaycfmFetchLecture(id).then(res => this.initShare('lecture'))
                break
            case 'channel':
                this.props.relaycfmFetchChannel(id).then(res => this.initShare('channel'))
                break
        }
    }
    componentWillUnmount () {
        this.props.relaycfmInit()
    }
    initShare (type) {
        if (!this.props.confirmLecture) {
            return
        }
        let shareInfo = {}
        if (type === 'lecture') {
            shareInfo = this.props.confirmLecture.share_info
        } else {
            shareInfo = this.props.confirmChannel.share_info
        }
        this.props.relaycfmShareInit({
            title: shareInfo.share_title,
            desc: shareInfo.share_description,
            imgUrl: shareInfo.share_icon,
            link: window.location.href,
        })
    }
    getPercentFee (money, percent) {
        return renderMoney((money || 0) * percent / 100)
    }
    getSuccessName (type, confirmLecture, confirmChannel) {
        if (type === 'lecture') {
            return confirmLecture ? confirmLecture.lecture.name : ''
        } else {
            return confirmChannel ? confirmChannel.channel.name : ''
        }
    }
    onClickSuccessOk () {
        if (this.props.location.query.type === 'lecture') {
            window.location.replace(`/lecture/${this.props.relayRes.data.lecture_id}`)
        } else {
            window.location.replace(`/channel/${this.props.relayRes.data.channel_id}`)
        }
    }
    onClickAlreadyOk () {
        window.location = '/account/'
    }
    onClickCancle () {
        history.go(-1)
    }
    onClickPaySuccessOk () {
        const paySuccessRes = this.props.paySuccessRes
        this.props.relaycfmSetIsPaySuccess(false)
        if (paySuccessRes.type === 'lecture') {
            window.location.replace(`/lecture/${paySuccessRes.id}`)
        } else {
            window.location.replace(`/channel/${paySuccessRes.id}`)
        }
    }
    render() {
        const { confirmPending, confirmChannel, confirmLecture, relayRes, fetchRes } = this.props
        const type = this.props.location.query.type
        if (confirmPending) return null
        return (
            <div className="relays-page">
                <Page>
                    <Pay />
                    <WKVisible create={confirmPending}>
                        <LoadMore loading></LoadMore>
                    </WKVisible>
                    {
                        type === 'lecture' ?
                            <RelayConfirmLecture getPercentFee={this.getPercentFee} lecture={confirmLecture} />
                                :
                            <RelayConfirmChannel getPercentFee={this.getPercentFee} channel={confirmChannel} />
                    }
                    <Dialog type="ios" title='温馨提示' show={relayRes.code === 0}
                        buttons={[this.cancleBtnStyle, { ...this.primaryBtnStyle, onClick: () => this.onClickSuccessOk() }]}
                    >
                        您已成功转载 {this.getSuccessName(type, confirmLecture, confirmChannel)}，现在就去看看吧
                    </Dialog>
                    <Dialog type="ios" title='温馨提示' show={this.props.isPaySuccess}
                        buttons={[
                            { ...this.cancleBtnStyle, onClick: () => this.onClickCancle() },
                            { ...this.primaryBtnStyle, onClick: () => this.onClickPaySuccessOk() },
                        ]}
                    >
                        您已成功支付并转载 {this.getSuccessName(type, confirmLecture, confirmChannel)}，现在就去看看吧
                    </Dialog>
                    <Dialog type="ios" title='温馨提示' show={fetchRes.code !== 0}
                        buttons={[
                            { ...this.cancleBtnStyle, onClick: () => this.onClickCancle() },
                            { ...this.primaryBtnStyle, onClick: () => this.onClickAlreadyOk() },
                        ]}
                    >
                        {fetchRes.msg}
                    </Dialog>
                </Page>
            </div>
        )
    }
}


export default connect(state => ({
    confirmPending: state.relayConfirm.confirmPending,
    confirmLecture: state.relayConfirm.confirmLecture,
    confirmChannel: state.relayConfirm.confirmChannel,
    relayRes: state.relayConfirm.relayRes,
    fetchRes: state.relayConfirm.fetchRes,
    isPaySuccess: state.relayConfirm.isPaySuccess,
    paySuccessRes: state.relayConfirm.paySuccessRes,
}), dispatch => bindActionCreators({ ...relaycfmAction }, dispatch))(RelayConfirmPage)



// WEBPACK FOOTER //
// ./src/pages/RelayConfirmPage.js